import { useEffect } from 'react';
import { useLang } from '../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../hooks/use-modal-params';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { useAdminsStore } from '../../../../../../store/use-admins-store';
import { useBranchesStore } from '../../../../../../store/use-branch-store';
import { useManagerStore } from '../../../../../../store/use-manager-store';

export const useCompanyAdmins = () => {
  const { addQueryParams } = useQueryParams();
  const { t, getLocale } = useLang();

  const { fetchBranches, place: branches } = useBranchesStore();
  const { list, deleteAdmin, restoreAdmin, isLoadingFetch, fetchAdmins } = useAdminsStore();
  const { managerProfile } = useManagerStore();

  useEffect(() => {
    fetchBranches({ n: 1000, since_id: 0, customCache: true, with_archive: false });
    fetchAdmins({ n: 1000, since_id: 0, with_archive: true });
  }, []);

  const { handleCloseModal, handleOpenModal, isOpen } = useModalParams('createAdmin');

  return {
    t,
    addQueryParams,
    handleCloseModal,
    handleOpenModal,
    isOpen,
    restoreAdmin,
    deleteAdmin,
    list,
    branches,
    getLocale,
    managerProfile,
    isLoadingFetch,
  };
};
